import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import { observer } from "mobx-react";
import { queryGetBulkSmsContactList } from "Apollo";
import LoadingPanel from "module-common/LoadingPanel";
import List from './member/List'
import styled, { css } from 'styled-components'
import UploadContact from "./member/UploadContactWithMutation";
import AddContact from './member/AddContact'
import { mutationDeleteContact, queryGetBulkSmsAccount } from "../../Apollo";
import { Button } from "antd";

export default compose(
    graphql(queryGetBulkSmsContactList, {
      name: 'contactList',
      fetchPolicy: 'network-only'
    }),
    graphql(mutationDeleteContact, {
        name: 'deleteContact'
    }),
    graphql(queryGetBulkSmsAccount, {
        name: 'account'
    })
)(
    observer(
        class ListView extends Component {  
            state = {
                isCreatingContact: false,
                isEdittingContact: false,
                contact: null
            }

            toggleCreateMember = (toggleValue) => {
                this.setState(state => ({...state, isCreatingContact: !!toggleValue}))
            }

            editContact = (contact) => {
                this.setState(state => ({...state, isCreatingContact: false, isEdittingContact: true, contact: contact}))        
            }

            onDelete = async (contact) => {
                const isOk = window.confirm(`"Are you sure to delete (${contact.firstName} ${contact.lastName}) ${contact.phoneNumber}?"`)
                if(isOk) {
                    try {
                        const result = await this.props.deleteContact({
                            variables: {
                                contactId: contact.id
                            },
                            refetchQueries: ['getBulkSmsContactList', 'queryGetBulkSmsContactList']
                        })
                    } catch(e) {
                        console.log(e)
                    }
                }
            }
            
            render() {
                const { contactList: { loading, getBulkSmsContactList }, account: { getBulkSmsAccount} = {} } = this.props;
                const { isCreatingContact, isEdittingContact } = this.state
                return (
                <React.Fragment>
                    <CreateMemberPanel>
                        {getBulkSmsAccount && <UploadContact accountId={getBulkSmsAccount.id} />}
                        {!isCreatingContact && <Button
                            color="blue"
                            size="large"
                            border
                            onClick={() => this.setState(state => ({...state, isCreatingContact: true}))}
                        >Add Contact</Button>}
                    </CreateMemberPanel>
                    {loading && <LoadingPanel />}
                    {isCreatingContact && getBulkSmsAccount.id && <AddContact 
                        accountId={getBulkSmsAccount.id}
                        onCancel={() => this.setState(state => ({...state, isCreatingContact: false, contact: null}))}
                        onSuccess={() => this.setState(state => ({...state, isCreatingContact: false, contact: null}))}
                    />}
                    {isEdittingContact && <AddContact 
                        contactId={this.state.contact.id}
                        firstName={this.state.contact.firstName}
                        lastName={this.state.contact.lastName}
                        phoneNumber={this.state.contact.phoneNumber}
                        selectedTagList={this.state.contact.tags}
                        onCancel={() => this.setState(state => ({...state, isEdittingContact: false, contact: null}))}
                        onSuccess={() => this.setState(state => ({...state, isEdittingContact: false, contact: null}))}
                    />}
                    {!loading && getBulkSmsContactList && !isCreatingContact && !isEdittingContact && <List 
                        members={getBulkSmsContactList} 
                        onEdit={contact => this.editContact(contact)} 
                        onDelete={contact => this.onDelete(contact)}
                    /> }                
                </React.Fragment>
                );
            }
        }
    )
);

const CreateMemberPanel = styled.div`
  height: 50px;
  width: 100%;
  padding: 10px 20px;
  display: flex;
  flex-direction: row-reverse;
  border-bottom: 1px solid #d2d3d5;
`
  


// WEBPACK FOOTER //
// ./src/module-bulk-sms/contact/MemberListWithQuery.js